import { createSelector } from 'reselect'

import { selectQbrState } from './selectQbrState'

export const selectEmptyOfferings = createSelector(
  [selectQbrState],
  (state) => state.selectedDocument?.EmptyOfferings
)
